import React from "react";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton, ModalSecondaryButton } from "../..";
import { useParams, useRoute, useModel, BCMSRecord, useBCMSContext, ModalClose } from "@bcm-dev/bcms-vite";

import Classes, { Card } from "model";
export default function LostStolenModal(props) {
  const { branding } = useModel();
  const controller = useBCMSContext();
  const navigate = useRoute();

  const { route } = props.data;
  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const cardType = card.type ?? "[Card Type]";
  const lastFour = card.lastFour ?? "XXXX";

  const lostStolenRoute = evt => {
    BCMSRecord.batch([
      Card.update({ ...card.record, isOn : false })
    ], controller, Classes);

    navigate(route);
  };
  
  return(
      <CustomModal className="lost-stolen-modal" id="LostStolenModal" title="Report Lost or Stolen">
        <CustomModalContent>
          <p className="text-center">Your {cardType} card ending in {lastFour} will be disabled and can no longer be used.</p>
        </CustomModalContent>
        <CustomModalFooter>
          <ModalPrimaryButton text="Continue" onClick={lostStolenRoute} close={true} id="LostStolenModal" />
          <ModalClose id="LostStolenModal">
            <ModalSecondaryButton text="Cancel" />
          </ModalClose>
        </CustomModalFooter>
      </CustomModal>
  );
}